import { connect } from "react-redux";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { ReactTitle } from "react-meta-tags";
import Modal from "../../../utils/customModal";
import * as instanceActions from "../../../../Redux/api";
import TableAdmissions from "../../../shared/admissions/table";
import {
  loadingHtml,
  errorContainer,
  sucessInfoModal,
} from "../../../utils/functions";
import noAproval from "../../../../../static/images/add-client-bsc.svg";
import * as NotificationActions from "../../../../Redux/actions/notificationsAction";
import {
  getNotifications,
  getTotalElements,
} from "../../../../Redux/reducer/notifications";
import NotificationApprovalDetail from "../../notifications/approvalDetail";
import { withTranslation } from "react-i18next";
import i18next from "i18next";
const filters = [
  {
    name: `${i18next.t("general.placeholders.name")} (${i18next.language
      .charAt(0)
      .toUpperCase()}${i18next.language.slice(1)})`,
    property: `nameTypeNotificationEmail${i18next.language
      .charAt(0)
      .toUpperCase()}${i18next.language.slice(1)}`,
    operator: "eq",
  },
];

const headers = [
  {
    grow: 2,
    selector: "createBy",
    name: `${i18next.t("admissions.headers.suppliers.notification_name_es")}`,
  },
  {
    grow: 2,
    selector: "name",
    name: `${i18next.t("admissions.headers.suppliers.notification_name_en")}`,
  },
  {
    grow: 2,
    selector: "createBy",
    name: `${i18next.t(
      "admissions.headers.suppliers.notification_description_es"
    )}`,
  },
  {
    grow: 2,
    selector: "updatedBy",
    name: `${i18next.t(
      "admissions.headers.suppliers.notification_description_en"
    )}`,
  },
  {
    grow: 2,
    selector: "action",
    name: `${i18next.t("general.headers.actions")}`,
    center: true,
  },
  {
    grow: 2,
    selector: "status",
    name: `Estado`,
    center: true,
  },
];
// const headers = [
//   { grow: 2, selector: "name",
//   name: `${i18next.t("notification.form.name")}`
// },
//   {
//     grow: 2,
//     selector: "country",
//     name: `${i18next.t("notification.form.country")}`,
//   },
//   {
//     grow: 2,
//     selector: "email",
//     name: `${i18next.t("notification.form.email")}`,
//   },
//   {
//     grow: 2,
//     selector: "updatedBy",
//     name: `${i18next.t("notification.form.updated_by")}`,
//   },
//   {
//     grow: 2,
//     selector: "action",
//     name: `${i18next.t("general.headers.actions")}`,
//     center: true,
//   },
// ];

export class NotificationApprovalsComponent extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      sizePerPage: 10,
      contentReady: false,
      modal: {
        show: false,
        content: null,
        onClose: undefined,
        showClose: false,
      },
      list: true,
      component: false,
      notificationId: 0,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    const { setFilters } = this.props;
    setFilters({ filters, search: this.getSearchResult });
    return this.getPendingData();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.props.setFilters({ filters: undefined, search: undefined });
    this.props.actions.clearNotifications();
  }

  getSearchResult = (property, value = "") => {
    var actionFilters = [];
    const cleanValue = value.trim();

    if (cleanValue !== "") {
      // Realizamos la busqueda por filtros
      var operator = "";
      filters.map((item) => {
        if (item.property == property) {
          operator = item.operator;
        }
      });
      actionFilters = [
        { property: property, operator: operator, value: cleanValue },
      ];
    }

    this.handlerTableChange({
      page: 0,
      sizePerPage: this.state.sizePerPage,
      customFilters: actionFilters,
    });
  };

  getPendingData() {
    const { page, sizePerPage } = this.state;
    const { getAllNotifications } = this.props.actions;

    return getAllNotifications(
      page,
      sizePerPage,
      [],
      true,
      "updateDate,DESC"
    ).then(() => {
      if (this._isMounted == true) {
        this.setState({ contentReady: true });
      }
    });
  }

  getData() {
    const { pending, t } = this.props;
    var resultData = [];
    console.log("data", pending);
    if (pending.length > 0) {
      pending.map((item) => {
        resultData.push({
          createBy: (
            <p
            // className={"admission-p record"}
            // onClick={() =>
            //   this.setState({
            //     list: false,
            //     component: true,
            //     notificationId: item.id,
            //   })
            // }
            >
              {item.nameTypeNotificationEmailEs}
            </p>
          ),
          name: item.nameTypeNotificationEmailEn,
          email: item.email,
          country: item.descriptionTypeNotificationEmailEs,
          updatedBy: item.descriptionTypeNotificationEmailEn,
          status: item.active ? "ACTIVO" : "INACTIVO",
          action: item.active
            ? t("general.states.MODIFICATION")
            : t("general.states.CREATION"),
          id: item.id,
        });
      });
    }

    return resultData;
  }
  // getData() {
  //   const { pending, t } = this.props;
  //   var resultData = [];
  //   console.log('data', pending)
  //   if (pending.length > 0) {
  //     pending.map((item) => {
  //       resultData.push({
  //         name: (
  //           <p
  //             className={"admission-p record"}
  //             onClick={() =>
  //               this.setState({
  //                 list: false,
  //                 component: true,
  //                 notificationId: item.id,
  //               })
  //             }
  //           >
  //             {item.name}
  //           </p>
  //         ),
  //         name: item.name,
  //         email: item.email,
  //         country: item.country.code,
  //         updatedBy: item.updateBy,
  //         action: item.active
  //           ? t("general.states.MODIFICATION")
  //           : t("general.states.CREATION"),
  //         id: item.id,
  //       });
  //     });
  //   }

  //   return resultData;
  // }

  finishAdmission = () => {
    var buttons = {
      SelBtn: {
        text: "Continuar",
        action: this.closeModal,
      },
    };

    var content = sucessInfoModal(
      "Admisión de notificaciones",
      `La operación fue realizada con éxito`,
      buttons
    );

    this.setState({
      modal: { content, show: true, showClose: true, onClose: this.closeModal },
    });
  };

  commitActions = (approve, elements) => {
    const { modal } = this.state;
    const {
      instance: { instanceAction },
    } = this.props;
    modal.content = loadingHtml();
    modal.show = true;

    this.setState({ modal });
    var updateStates = [];

    Object.keys(elements).map((key) => {
      var notificationId = key.split("-")[1];
      updateStates.push({
        id: notificationId,
        approve: approve,
      });

      return true;
    });

    return instanceAction(
      "/notification-emails/approve-or-rejected",
      "put",
      updateStates
    )
      .then((response) => {
        if (response.data.data[0].success === false) {
          modal.show = true;
          modal.content = errorContainer(
            "Error",
            response.data.data[0].message,
            {
              continueBtn: {
                text: "Continuar",
                action: this.closeModal,
              },
            }
          );
        } else if (response.data.notifications == null) {
          this.finishAdmission();
        }

        this.setState({ contentReady: false });
        this.getPendingData();
      })
      .catch((err) => {
        if (
          err.response !== undefined &&
          Array.isArray(err.response.data.notifications)
        ) {
          const notification = err.response.data.notifications[0];
          modal.content = errorContainer(
            notification.message,
            notification.description,
            { cancelBtn: { text: "Cerrar", action: () => this.closeModal() } }
          );
        }
        modal.onClose = () => this.closeModal();

        this.setState({ contentReady: false, modal });
        this.getPendingData();
      });
  };

  handlerTableChange = ({ page, sizePerPage, customFilters = [] }) => {
    const { getAllNotifications } = this.props.actions;

    return getAllNotifications(
      page,
      sizePerPage,
      customFilters,
      true,
      "updateDate,DESC"
    ).then(() => {
      this.setState({ page, sizePerPage });
    });
  };

  closeModal = () => {
    this.setState({
      modal: {
        show: false,
        content: null,
        onClose: undefined,
        showClose: false,
      },
    });
  };

  closeModalClient = () => {
    this.setState({
      modalClient: { show: false, type: "loading" },
    });
  };

  closeInfo = () => {
    this.setState({
      list: true,
      component: false,
    });
  };

  render() {
    const {
      contentReady,
      sizePerPage,
      page,
      modal,
      list,
      component,
      notificationId,
    } = this.state;
    const data = this.getData();

    return (
      <React.Fragment>
        <ReactTitle title={`Admision de Notificaciones - Reverse Factoring`} />
        {contentReady ? (
          this.props.pending.length > 0 ? (
            list && (
              <React.Fragment>
                <TableAdmissions
                  headers={headers}
                  data={data}
                  page={page}
                  addmissionType={`notification`}
                  sizePerPage={sizePerPage}
                  totalSize={this.props.total}
                  onTableChange={this.handlerTableChange}
                  submitAdmissions={this.commitActions}
                />
              </React.Fragment>
            )
          ) : (
            <div id="blankAprrovals">
              <img src={noAproval} className="clientImage" />
              <p>
                El sistema no posee admisiones
                <br />
                pendientes.
              </p>
              <div className="line-aproval"></div>
            </div>
          )
        ) : (
          <div className="loader innner"></div>
        )}
        {component && (
          <NotificationApprovalDetail
            closeInfo={this.closeInfo}
            notificationId={notificationId}
          />
        )}
        <Modal
          show={modal.show}
          handleClose={modal.onClose}
          showClose={modal.showClose}
        >
          {modal.content}
        </Modal>
      </React.Fragment>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    pending: getNotifications(state),
    total: getTotalElements(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(NotificationActions, dispatch),
    instance: bindActionCreators(instanceActions, dispatch),
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatch)(NotificationApprovalsComponent)
);
